<template>
  <div id="app" class="container-fluid pl-0 pr-0">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  methods: {
    loadEvent() {
      

      let url = '/catalog/events/public'
      let method = 'post'
      this.$store.dispatch(method, {'url':url, data: {event_key_id: this.$store.getters.eventKeyId}, headers:{}})
        .then((resp) => {
          this.$store.commit('set_event', resp.data)
          this.$nextTick(() => {
            this.listenChannel()
          })
        })
        .catch(err => {
          if(err && err.error) alert(err.error)
        })
    },
    listenChannel() {
      Vue.use(require('vue-pusher'), {
        api_key: 'ae458246b12fb963bcc4',
        options: {
          cluster: 'mt1',
          reconnectionAttempts: 60,
          encrypted: true,
          authEndpoint: this.$store.getters.auth_url_chat+'broadcasting/auth',
          auth: {
            params: { foo: 'bar' },
            headers: {
              'V-Auth': true,
              'Virtual-Id': 'unID',
              'Chat-Id': '123456'
            },
          }
        }
      })

      let channel = this.$pusher.subscribe('events-'+this.$store.getters.eventKeyId);

      channel.bind('EventUpdated', data => {
        this.$store.commit('set_event', data)
      })

      let channel_alert = this.$pusher.subscribe('alerts-'+this.$store.getters.eventKeyId);
  
      channel_alert.bind('AlertPublished', data => {
        if(data.alert.to_chat && this.assistant.id) {
          this.$eventHub.$emit(
            'addToChatMessage',
            {
              'id': Date.now(),
              'message': data.alert.alert, 
              'sent_by': 'Operador', 
              'assistant_id':'M-ALL'
            }
          )
        } else {
          this.$eventHub.$emit(
            'showAlert',
            data.alert
          )
        }
      })

      let channel_message = this.$pusher.subscribe('messages-'+this.$store.getters.eventKeyId);
  
      channel_message.bind('MessagePublished', data => {
        if(this.$store.getters.assistant.key_id === data.assistant.key_id) {
          if(data.sent_by !== null)
            this.$eventHub.$emit(
              'addToChatMessage',
              {'id': data.id,'message': data.message, 'sent_by': data.sent_by, 'assistant_id':data.assistant.id}
            )
        }
      })
    },
    listenProtectChannel() {
      this.$pusher.subscribe('session-'+this.assistant.session_id)
        .bind('pusher:subscription_succeeded', function() {
          console.debug("suscrito")
        })

      this.$pusher.subscribe('events-'+this.$store.getters.eventKeyId)
        .bind('StartPoll', start_poll => {
          this.$store.commit('set_data_poll', [start_poll.poll])
        })
        .bind('EndPoll', end_poll => {
          this.$store.commit('set_data_poll', end_poll.poll)
        })
        .bind('SwopWordCloud', data => {
          this.$store.commit('set_data_word_cloud', [data.wordCloud])
        })

      this.$pusher.subscribe('ratings-'+this.$store.getters.eventKeyId)
        .bind('ActivateRating', data => {
          this.$store.commit('set_data_rating', [data.rating])
        })
        .bind('DeactivateRating', data => {
          this.$store.commit('set_data_rating', data.rating)
        })
    },
    unsuscribeProtectChannel() {
      this.$store.commit('logout')
      this.$pusher.unsubscribe('session-'+this.assistant.session_id)
      this.$pusher.unsubscribe('events-'+this.$store.getters.eventKeyId)
      this.$pusher.unsubscribe('ratings-'+this.$store.getters.eventKeyId)
    },
    onchange() {
      this.online = navigator.onLine;
    }
  },
  data() {
    return {
      online: navigator.onLine
    }
  },
  beforeMount () {
    this.loadEvent()
  },
  created () {
    this.$eventHub.$on('unsuscribeProtectChannel', this.unsuscribeProtectChannel);
  },
  computed: {
    assistant : function() {
      return this.$store.getters.assistant
    },
    isLoggedIn : function() {
      return this.$store.getters.isLoggedIn
    },
    dataRating : function() {
      return this.$store.getters.data_rating
    },
    dataPoll: function() {
      return this.$store.getters.data_poll
    },
    dataWordCloud: function() {
      return this.$store.getters.data_word_cloud
    },
    room : function() { return this.$store.getters.room },
  },
  watch: {
    assistant: function(newValue, oldValue) {
      if(newValue) {
        /* newValue.active_word_clouds.forEach(element => {
          console.log(element)
          this.$eventHub.$emit('activateWord', element)
        }); */
      }
    },
    online: function(newValue, oldValue) {
      this.$store.commit('set_online', newValue)
    },
    isLoggedIn: function(newValue, oldValue) {
      if(newValue) {
        this.listenProtectChannel()
      }
    },
    dataRating: function(newValue, oldValue) {
      if(newValue.length>0) {
        newValue.forEach(element => {
          if(!this.$store.getters.isModuleActive('PrecentialRooms')) {
            if((element.params == null || element.params == '')) this.$eventHub.$emit('activateRating', element)
          } else if(element.params != null && this.room && (element.params == this.room.value)) {
            this.$eventHub.$emit('activateRating', element)
          }
        });
      } else {
        this.$eventHub.$emit('deactivateRating', newValue)
      }
    },
    dataPoll: function(newValue, oldValue) {
      if(newValue.length>0) {
        newValue.forEach(element => {
          if(!this.$store.getters.isModuleActive('PrecentialRooms')) {
            if(element.room == null || element.room == '') this.$eventHub.$emit('startPoll',element)
          } else if(this.room && element.room == this.room.value) {
            this.$eventHub.$emit('startPoll',element)
          }
        });
      } else {
        this.$eventHub.$emit(
          'endPoll',
          newValue
        )
      }
    },
    dataWordCloud: function(newValue, oldValue) {
      if(newValue.length>0) {
        newValue.forEach(element => {
          if(element.active == 1) {
            if(element.room == null || element.room == '') {
              this.$eventHub.$emit('activateWord',element)
            } else if(this.room && element.room == this.room.value) {
              this.$eventHub.$emit('activateWord',element)
            } 
          } else {
            this.$eventHub.$emit(
              'deactivateWord',
              element
            )
          }
        })
      }
    },
    room: function(newValue, oldValue) {
      if(this.dataPoll.length>0) {
        this.dataPoll.forEach(element => {
          if(!this.$store.getters.isModuleActive('PrecentialRooms')) {
            if(element.room == null || element.room == '') this.$eventHub.$emit('startPoll',element)
          } else if(this.room && element.room == this.room.value) {
            this.$eventHub.$emit('startPoll',element)
          }
        });
      }
      if(this.dataRating.length>0) {
        this.dataRating.forEach(element => {
          if(!this.$store.getters.isModuleActive('PrecentialRooms')) {
            if((element.params == null || element.params == '')) this.$eventHub.$emit('activateRating', element)
          } else if(element.params != null && this.room && (element.params == this.room.value)) {
            this.$eventHub.$emit('activateRating', element)
          }
        });
      }
    }
  },
  mounted () {
    window.addEventListener("online", this.onchange);
    window.addEventListener("offline", this.onchange);
    this.onchange();
  },
  beforeDestroy () {
    window.removeEventListener("online", this.onchange);
    window.removeEventListener("offline", this.onchange);
  },
})
</script>

<style src="./styles/app.scss" lang="scss" />